import * as React from 'react'
import { Controller } from 'react-hook-form'
import { TimePicker as MUITimePicker } from '@mui/x-date-pickers/TimePicker'
import dayjs from 'dayjs'

import gridWrapper from 'Utils/GridWrapper'
import { FormTimeProps } from 'Types'

const FormTimePicker: React.FC<FormTimeProps> = ({
  fieldName,
  label,
  control,
  controllerProps,
  ...timeFieldProps
}) => {
  return (
    <Controller
      name={fieldName}
      {...controllerProps}
      render={({ field: { onChange, ref, value } }) => {
        return (
          <MUITimePicker
            {...timeFieldProps}
            label={label}
            onChange={onChange}
            inputRef={ref}
            value={dayjs(value)}
          />
        )
      }}
      control={control}
    />
  )
}

export const TimePicker = ({
  disableGrid,
  disableSpacer,
  gridProps,
  spacerProps,
  ...props
}: FormTimeProps) => {
  return gridWrapper<FormTimeProps>({
    disableGrid,
    disableSpacer,
    Component: FormTimePicker,
    props,
    gridProps,
    spacerProps,
    key: props.fieldName
  })
}

export default TimePicker
